var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 31,
    viewBox: "0 0 21 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.94116,
    width: 3.41176,
    height: 31,
    fill: "#D5D5D5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.11768,
    y: 5.16675,
    width: 17.0588,
    height: 6.88889,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.411743,
    y: 15.5002,
    width: 20.4706,
    height: 12.0556,
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.b1e762f85bb1c4d21ecb66eeb57ebf30.svg";
export { ForwardRef as ReactComponent };